import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output } from '@angular/core';
import { NgIf, NgTemplateOutlet } from '@angular/common';
import { SmsAuthSetupStepComponent } from 'app/components/v2-layout/shared/two-factor-setup-steps/sms-auth-setup-step.component';
import { RECOVERY_CODES_GATE_COPY } from 'app/components/v2-layout/shared/two-factor-setup-steps/recovery-codes-copy';
import { GenericDialogResult } from '../../../../../shared/generic-mat-dialog/generic-dialog-result';

const DEFAULT_TITLE = 'Enable text message authentication';

@Component({
    selector: 'app-setup-sms-authentication',
    templateUrl: './setup-sms-authentication.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        NgTemplateOutlet,
        SmsAuthSetupStepComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SetupSmsAuthenticationComponent
{
    @Output() closed = new EventEmitter<GenericDialogResult | null>();

    title = DEFAULT_TITLE;

    /** Set once the recovery codes are on screen: escape, the backdrop and the X would discard the only view of them. */
    locked = false;

    private _open = false;

    get open(): boolean {
        return this._open;
    }

    @Input() set open(value: boolean) {
        if (value && !this._open) {
            this.title = DEFAULT_TITLE;
            this.locked = false;
        }
        this._open = value;
    }

    onShowingRecoveryCodes(): void {
        this.title = RECOVERY_CODES_GATE_COPY.title;
        this.locked = true;
    }

    onCompleted(): void {
        this.closed.emit({success: true});
    }

    onCancelled(): void {
        this.closed.emit(null);
    }

    onDismiss(): void {
        if (!this.locked) {
            this.closed.emit(null);
        }
    }
}
